import { mapState } from 'vuex';
import MultiSearch from '@/components/core/MultiSearch/MultiSearch.vue';
import virtualDeviceSearchConfig from '@/components/core/MultiSearch/Mixins/virtualDeviceSearchConfig';
import { waitForRef } from '@/utils/vuex';
export default {
  name: 'CoreCsvExportSearchVirtualDevices',
  components: {
    MultiSearch
  },
  mixins: [virtualDeviceSearchConfig],
  props: {
    search: {
      type: Array,
      required: false,
      default: () => []
    },
    operator: {
      type: String,
      required: false,
      default: 'AND'
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false
    },
    copyMode: {
      type: Boolean,
      required: false,
      default: false
    },
    accountId: {
      type: Number,
      required: false,
      default: null
    }
  },
  data: function () {
    return {};
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'color'])
  },
  mounted() {
    const join = this.join;
    const rules = this.search.map(item => ({
      field: item.param,
      value: item.search,
      key: item.key,
      condition: item.condition || 'is'
    }));
    waitForRef(this, '$refs.multiSearch').then(ref => {
      ref.loadRules({
        rules,
        join
      });
      this.onSearchUpdate({
        rules,
        join
      });
    }).catch(error => {
      console.error(error);
    });
  },
  methods: {
    onSearchUpdate(search) {
      const rules = (search || {}).rules || [];
      const join = (search || {}).join || 'AND';
      const searchItems = rules.map(rule => ({
        param: rule.field,
        search: rule.value,
        key: rule.key,
        condition: rule.condition
      }));
      this.$emit('updated', searchItems, join);
    }
  }
};